import { Navbar }       from "../components/Navbar";
import { Hero }         from "../components/Hero";
import { Problema }     from "../components/Problema";
import { Solucion }     from "../components/Solucion";
import { Comunidad }    from "../components/Comunidad";
import { Temas }        from "../components/Temas";
import { Membresia }    from "../components/Membresia";
import { QuienesSomos } from "../components/QuienesSomos";
import { CTAFinal }     from "../components/CTAFinal";
import { Contacto }     from "../components/Contacto";
import { Footer }       from "../components/Footer";

export default function Landing() {
  return (
    <div style={{ fontFamily: "var(--font-body)", background: "var(--bg)", color: "var(--ink)", overflowX: "hidden" }}>
      <Navbar />
      <main>
        <Hero />
        <Problema />
        <Comunidad />
        <Solucion />
        <div style={{
          position: "relative",
          overflow: "hidden",
          background: "linear-gradient(135deg, #1E1812 0%, #251E14 50%, #1A1510 100%)",
        }}>
          <img
            src="/logo-psicodosis.png"
            alt=""
            style={{
              position: "absolute", right: -100, top: "50%", transform: "translateY(-50%)",
              width: 500, opacity: 0.04, pointerEvents: "none", userSelect: "none", zIndex: 0,
            }}
          />
          <div style={{
            position: "absolute", width: 400, height: 400, borderRadius: "50%",
            background: "radial-gradient(circle, rgba(196,154,138,0.12) 0%, transparent 70%)",
            top: -100, left: -100, pointerEvents: "none", zIndex: 0, filter: "blur(40px)",
          }} />
          <div style={{
            position: "absolute", width: 300, height: 300, borderRadius: "50%",
            background: "radial-gradient(circle, rgba(184,212,200,0.08) 0%, transparent 70%)",
            top: "30%", right: "5%", pointerEvents: "none", zIndex: 0, filter: "blur(50px)",
          }} />
          <div style={{
            position: "absolute", width: 200, height: 200, borderRadius: "50%",
            background: "radial-gradient(circle, rgba(212,196,181,0.1) 0%, transparent 70%)",
            bottom: "10%", left: "20%", pointerEvents: "none", zIndex: 0, filter: "blur(35px)",
          }} />
          <div style={{
            position: "absolute", width: 350, height: 350, borderRadius: "50%",
            background: "radial-gradient(circle, rgba(196,154,138,0.07) 0%, transparent 70%)",
            bottom: -50, right: -50, pointerEvents: "none", zIndex: 0, filter: "blur(60px)",
          }} />

          <Temas />
          <div style={{
            position: "relative", zIndex: 1,
            width: "120px",
            height: "1px",
            background: "linear-gradient(to right, transparent, rgba(196,154,138,0.4), transparent)",
            margin: "0 auto",
            padding: "0",
          }} />
          <QuienesSomos />
        </div>
        <Membresia />
        <Contacto />
        <CTAFinal />
      </main>
      <Footer />
    </div>
  );
}
